export default __webpack_public_path__ + "static/media/logo.f2ecaa17.png";